import { Box, Button, TextField, Typography } from '@mui/material';
import { apiUrlBase, apiUrlPrefix } from '../../../../config';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMountain, faWater, faDroplet, faPeopleGroup, faUtensils, faSailboat, faUsers, faUserGroup } from '@fortawesome/free-solid-svg-icons';

const Pepeha = ({ selected, error, setError }) => {

  useEffect(() => {
    getPepeha();
  }, []);

  const getPepeha = async () => {
    const userId = localStorage.getItem('userId');
    const response = await fetch(`${apiUrlBase}Ancestry/GetAncestry?userId=${userId}`, {
      method: "GET",
      credentials: "include",
      headers: { 'Content-Type': 'application/json' },
    })
    if (response.ok) {
      const data = await response.json();
      const pepehaInfo = data.userInfo.ancestry;
      formik.setFieldValue('mountain', pepehaInfo?.mountain);
      formik.setFieldValue('river', pepehaInfo?.river);
      formik.setFieldValue('spring', pepehaInfo?.spring);
      formik.setFieldValue('ancestralHome', pepehaInfo?.ancestralHome);
      formik.setFieldValue('diningHall', pepehaInfo?.diningHall);
      formik.setFieldValue('subTribe', pepehaInfo?.subTribe);
      formik.setFieldValue('tribe', pepehaInfo?.tribe);
      formik.setFieldValue('canoe', pepehaInfo?.canoe);
      return;
    }
  }

  const updateAncestry = async ({ mountain, river, spring, ancestralHome, diningHall, subTribe, tribe, canoe }) => {
    const response = await fetch(`${apiUrlBase}Ancestry/UpdateCulturalIdentity`, {
      method: "POST",
      credentials: "include",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        Id: localStorage.getItem('userId'),
        mountain: mountain,
        river: river,
        spring: spring,
        ancestralHome: ancestralHome,
        diningHall: diningHall,
        subTribe: subTribe,
        tribe: tribe,
        canoe: canoe,
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      setError(errorData);
      throw new Error(errorData.message || "Failed to update pepeha");
    }
    setError("");

    getPepeha();
    return await response.json();
  };

  const formik = useFormik({
    initialValues: {
      mountain: '',
      river: '',
      spring: '',
      ancestralHome: '',
      diningHall: '',
      subTribe: '',
      tribe: '',
      canoe: '',
    },
    validationSchema: Yup.object({}), //Doing nothing
    onSubmit: (values) => {
      changePasswordMutation.mutate(values);
    },
  });

  const changePasswordMutation = useMutation({
    mutationFn: updateAncestry,
    onSuccess: (data) => {
      if (data) {
      } else {
        throw new Error('Unexpected response structure');
      }
    },
    onError: (error) => {
      setError(error.message); // Set the error message
    },
  });

  return (
    <Box component="form" className={selected === 4 ? '' : 'hidden'} onSubmit={formik.handleSubmit} sx={{ width: '100%', maxWidth: '400px', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <>
        <Typography variant="h6" sx={{ cursor: 'pointer' }} >Pepeha:</Typography>

        <Typography fontSize={'12px'} sx={{ color: 'red' }}>{error}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faMountain} size="2x" />
          <TextField
            label="Maunga/Mountain"
            type="text"
            name="mountain"
            fullWidth
            value={formik.values.mountain}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mountain && !!formik.errors.mountain}
            helperText={formik.touched.mountain && formik.errors.mountain}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faWater} size="2x" />
          <TextField
            label="Awa/River"
            type="text"
            name="river"
            fullWidth
            value={formik.values.river}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.river && !!formik.errors.river}
            helperText={formik.touched.river && formik.errors.river}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faDroplet} size="2x" />
          <TextField
            label="Punawai/Spring"
            type="text"
            name="spring"
            fullWidth
            value={formik.values.spring}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.spring && !!formik.errors.spring}
            helperText={formik.touched.spring && formik.errors.spring}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faPeopleGroup} size="2x" />
          <TextField
            label="Whare tipuna/Ancestral house"
            type="text"
            name="ancestralHome"
            fullWidth
            value={formik.values.ancestralHome}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.ancestralHome && !!formik.errors.ancestralHome}
            helperText={formik.touched.ancestralHome && formik.errors.ancestralHome}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faUtensils} size="2x" />
          <TextField
            label="Whare kai/Dining hall"
            type="text"
            name="diningHall"
            fullWidth
            value={formik.values.diningHall}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.diningHall && !!formik.errors.diningHall}
            helperText={formik.touched.diningHall && formik.errors.diningHall}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faUserGroup} size="2x" />
          <TextField
            label="Hapu/Sub tribe "
            type="text"
            name="subTribe"
            fullWidth
            value={formik.values.subTribe}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.subTribe && !!formik.errors.subTribe}
            helperText={formik.touched.subTribe && formik.errors.subTribe}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faUsers} size="2x" />
          <TextField
            label="Iwi/Tribe"
            type="text"
            name="tribe"
            fullWidth
            value={formik.values.tribe}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.tribe && !!formik.errors.tribe}
            helperText={formik.touched.tribe && formik.errors.tribe}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'row' }}>
          <FontAwesomeIcon icon={faSailboat} size="2x" />
          <TextField
            label="Waka/Canoe"
            type="text"
            name="canoe"
            fullWidth
            value={formik.values.canoe}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.canoe && !!formik.errors.canoe}
            helperText={formik.touched.canoe && formik.errors.canoe}
          />
        </Box>

        <Button
          type="submit"
          variant="contained"
          disabled={changePasswordMutation.isPending}
        >
          {changePasswordMutation.isPending ? 'Processing...' : 'Update Pepeha'}
        </Button>
      </>
    </Box>
  )
};

export default Pepeha;